const styles = theme => ({

    callLogDateField: {
        display: 'flex',
        marginTop: '10px',
        marginRight: '20px',
        marginBottom: '10px'
    },

    datePickerWrapper: {
        marginRight: '10px',
    },

    datePicker: {
        width: '200px',
        backgroundColor: '#131E2E',
        // This targets the root element of the InputBase component inside the DatePicker component. It sets the text color to white (#FFFFFF).
        '& .MuiInputBase-root': {
            color: '#FFFFFF',
            height: '48px',
            padding: '6px 10px',
        },
        '& .MuiInputLabel-root': {
            color: '#FFFFFF',
            fontFamily: 'cardiuma-regular',
            fontSize: '14px',
            fontStyle: 'normal',
        },
        '& .MuiSvgIcon-root': {
            color: '#FFFFFF',
        }
    },

    callInfo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '120px',
        height: '34px',
        margin: '10px 0 0 12px',
        color: 'white',
        backgroundColor: '#131E2E',
        fontFamily: 'cardiuma-regular',
        fontSize: '14px',
        fontStyle: 'normal',
        borderRadius: '10px'
    }
})

export default styles